module.exports = __webpack_public_path__ + "img/landscapebg3.150e3e52.jpg";